import React, { useState } from 'react';
import styled, { keyframes } from 'styled-components';

interface ImageModalProps {
    imageUrl: string;
    onClose: () => void;
}

const ImageModal: React.FC<ImageModalProps> = ({ imageUrl, onClose }) => {
    const [isLoaded, setIsLoaded] = useState(false);

    return (
        <ModalOverlay onClick={onClose}>
            <ModalContent onClick={e => e.stopPropagation()}>
                <ModalImage 
                    src={imageUrl} 
                    alt="매수신청대리인 등록증" 
                    onLoad={() => setIsLoaded(true)}
                    $isLoaded={isLoaded}
                />
                <CloseButton onClick={onClose} $isVisible={isLoaded}>✕</CloseButton>
            </ModalContent>
        </ModalOverlay>
    );
};

export default ImageModal;

const fadeIn = keyframes`
    from {
        opacity: 0;
        transform: scale(0.95);
    }
    to {
        opacity: 1;
        transform: scale(1);
    }
`;

const ModalOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.75);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
`;

const ModalContent = styled.div`
    position: relative;
    width: 95%;
    height: 95vh;
    display: flex;
    justify-content: center;
    align-items: center;
`;

const ModalImage = styled.img<{ $isLoaded: boolean }>`
    max-width: 100%;
    max-height: 90vh;
    object-fit: contain;
    opacity: ${props => props.$isLoaded ? 1 : 0};
    animation: ${fadeIn} 0.2s ease-out;
`;

const CloseButton = styled.button<{ $isVisible: boolean }>`
    position: absolute;
    top: 20px;
    right: 20px;
    background: rgba(255, 255, 255, 0.2);
    border: none;
    color: white;
    font-size: 24px;
    width: 40px;
    height: 40px;
    cursor: pointer;
    border-radius: 50%;
    opacity: ${props => props.$isVisible ? 1 : 0};
    transition: opacity 0.2s;
    
    &:hover {
        background: rgba(255, 255, 255, 0.3);
    }
`;